module.exports = __webpack_public_path__ + "static/pid-ug-25-en-consentbutton-635b46f54bc8c47212395f46e1e90f8a.png";